import type { IconData } from '@stacksjs/iconify-core'

export const clockSeven: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 6a1.003 1.003 0 0 0-1 1v4.73L9.4 14.5a1 1 0 1 0 1.73 1l1.69-2.93A1 1 0 0 0 13 12V7a1.003 1.003 0 0 0-1-1\"/><path fill=\"currentColor\" d=\"M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m1 10a1 1 0 0 1-.18.57l-1.69 2.93a1 1 0 1 1-1.73-1l1.6-2.77V7a1 1 0 0 1 2 0Z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default clockSeven
